
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullSessionFragmentAdmin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullLineupFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"streams"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreamFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rosters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullSessionRosterFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"judgeAssignments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullSessionJudgeAssignmentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"rotations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullRotationFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"squads"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullSquadFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionTeams"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullSessionTeamFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":947}};
    doc.loc.source = {"body":"#import './SessionFragment.graphql'\n#import './FullLineupFragment.graphql'\n#import './FullRoutineFragment.graphql'\n#import './FullSquadFragment.graphql'\n#import './StreamFragment.graphql'\n#import './FullSessionRosterFragment.graphql'\n#import './FullSessionJudgeAssignmentFragment.graphql'\n#import './FullRotationFragment.graphql'\n#import './FullSessionTeamFragment.graphql'\n\nfragment FullSessionFragmentAdmin on Session {\n  ...SessionFragment\n  lineups {\n    items {\n      ...FullLineupFragment\n    }\n  }\n  streams {\n    items {\n      ...StreamFragment\n    }\n  }\n  rosters {\n    items {\n      ...FullSessionRosterFragment\n    }\n  }\n  judgeAssignments {\n    items {\n      ...FullSessionJudgeAssignmentFragment\n    }\n    nextToken\n    startedAt\n  }\n  rotations {\n    items {\n      ...FullRotationFragment\n    }\n  }\n  squads {\n    items {\n      ...FullSquadFragment\n    }\n  }\n  sessionTeams {\n    items {\n      ...FullSessionTeamFragment\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./SessionFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullLineupFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullRoutineFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullSquadFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./StreamFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullSessionRosterFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullSessionJudgeAssignmentFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullRotationFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullSessionTeamFragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FullSessionFragmentAdmin"] = oneQuery(doc, "FullSessionFragmentAdmin");
        
